import React, { createContext } from "react"
import { useStaticQuery, graphql } from "gatsby"

// Context作成
const StringDataContext = createContext()

// Providerコンポーネント
const StringDataProvider = ({ children }) => {
  const data = useStaticQuery(graphql`
    query {
      allMdx(
        filter: { internal: { contentFilePath: { regex: "/(/string/)/" } } }
      ) {
        nodes {
          fields {
            slug
          }
          frontmatter {
            date
            brand
            category
            channel
            channelId
            colors
            youtubeId
            title
            thumbnail {
              childImageSharp {
                gatsbyImageData
              }
            }
            technologies
            tags
            slug
            name
            jp
            description
            url
            amazon
            rakuten
            material
            thickness
            explanation
          }
          internal {
            contentFilePath
          }
        }
      }
    }
  `)
  return (
    <StringDataContext.Provider value={data}>
      {children}
    </StringDataContext.Provider>
  )
}

export { StringDataProvider, StringDataContext }
